var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('RouterLink',{staticClass:"tw-font-semibold tw-text-primary-500 hover:tw-underline",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('a',_vm._b({staticClass:"tw-font-semibold tw-text-primary-500 hover:tw-underline",attrs:{"href":_vm.href}},'a',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }